import React from 'react';
import { Shield, Code, Briefcase, Trophy, Users, Clock } from 'lucide-react';

const AboutPage = () => {
  const features = [
    {
      icon: Shield,
      title: "Industry Expert Instructors",
      description: "Learn from certified professionals with real-world cybersecurity experience and industry certifications"
    },
    {
      icon: Code,
      title: "Hands-on Practical Labs",
      description: "Access to 30+ days of lab environment with real-world scenarios and cutting-edge security tools"
    },
    {
      icon: Briefcase,
      title: "Placement Assistance",
      description: "Dedicated placement support with resume building, interview prep, and connections to top companies"
    },
    {
      icon: Trophy,
      title: "Industry Certifications",
      description: "Earn recognized certifications to boost your career prospects"
    },
    {
      icon: Users,
      title: "Community Support",
      description: "Join 340K+ strong community of cybersecurity enthusiasts, alumni network, and peer learning"
    },
    {
      icon: Clock,
      title: "Lifetime Access",
      description: "Get lifetime access to course materials, updates, and exclusive resources for continuous learning"
    }
  ];

  return (
    <section id="about" className="py-16 sm:py-24 bg-gray-900 relative overflow-hidden min-h-screen pt-20 sm:pt-32">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-orange-600 rounded-full filter blur-3xl animate-pulse"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <span className="text-red-500 font-semibold text-sm uppercase tracking-wider">Why Choose Us</span>
              <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
                Job-Ready Programs to Master{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500">
                  Cybersecurity Skills
                </span>
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed">
                We provide world-class cybersecurity education with in-depth training by industry professionals and hands-on practical experience to prepare students for successful careers in ethical hacking, digital forensics, penetration testing, and network security.
              </p>
            </div>

            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-red-500/20">
              <img
                src="https://images.pexels.com/photos/6964137/pexels-photo-6964137.jpeg?w=800"
                alt="Cybersecurity Training"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent"></div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-950/50 border border-gray-800 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300">
                <div className="text-3xl font-bold text-red-500 mb-2">100%</div>
                <div className="text-gray-400">Practical Training</div>
              </div>
              <div className="bg-gray-950/50 border border-gray-800 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300">
                <div className="text-3xl font-bold text-red-500 mb-2">24/7</div>
                <div className="text-gray-400">Learning Support</div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-gray-950/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-red-500/10 hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <feature.icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-white mb-2 group-hover:text-red-500 transition-colors">
                      {feature.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPage;